import React from "react";

const PulsingLogo = ({ alt = "Logo", size = 150 }) => {
  const styles = {
    width: size,
    height: "auto",
    animation: "pulse 1.5s infinite ease-in-out",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        marginTop: "20px",
      }}
    >
      <img
        src="../../../cardfarm-logo192.webp"
        alt={alt}
        style={styles}
        loading="lazy"
      />
      <p style={{ margin: 0, fontWeight: "bold" }}>Loading... Please wait</p>
      <style>
        {`
          @keyframes pulse {
            0% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.1);
              opacity: 0.8;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PulsingLogo;
